import { Tab } from './types';

const tabTheme: Tab = {
	colors: {
		active: '',
		bar: '',
		default: '',
		divider: '',
		modes: {
			light: {
				active: 'neutral.900',
				bar: 'primary.500',
				default: 'neutral.600',
				divider: 'neutral.100'
			},
			dark: {
				active: 'neutral.100',
				bar: 'primary.500',
				default: 'neutral.400',
				divider: '#FFFFFF1A'
			}
		}
	}
};

export default tabTheme;
